import { Attributes, NeoModel, NumberUtils } from '@singularsystems/neo-core';
import { InstrumentLookupBase } from 'st-common/Awards';
import CurrencyLookup from './CurrencyLookup';

@NeoModel
export default class InstrumentLookup extends InstrumentLookupBase {

    /** The rate to convert from the instrument currency to the participants selected currency. */
    @Attributes.Observable()
    public rate: number | null = null;

    /** The last rate used to convert from instrument currency to the participants previously selected currency. */
    @Attributes.Observable()
    public lastRate: number | null = null;

    /** Currency the user wants to convert to */
    public conversionCurrency: CurrencyLookup | null = null;

    // This is set from the prices in the portfolio tranches in AppDataLookup.setup
    @Attributes.Observable()
    public price: number | null = null;

    @Attributes.Float()
    @Attributes.Observable()
    public customPrice: number | null = null;

    @Attributes.Float()
    public get customOrDefaultPrice() {
        return this.customPrice ?? this.price!;
    }
    public set customOrDefaultPrice(value: number) {
        this.customPrice = value;
    }

    public get displayCurrencySymbol(): string {
        return this.rate === null ? this.currencySymbol : this.conversionCurrency!.symbol;
    }

    public getConversionText(): string | null {
        if (this.conversionCurrency && this.rate && this.rate !== 1) {
            return `1 ${this.currencyCode} = ${NumberUtils.format(this.rate, "#,##0.00##")} ${this.conversionCurrency.currencyCode}`;
        } else {
            return null;
        }
    }
}